import { i18n } from "@/services/i18n";
import Form from "../Form.vue";

export default {
  props: {
    name: {
      required: true,
      type: String
    },
    label: {
      default() {
        const fullKey = "attributes." + this.name;

        if (i18n.te(fullKey)) {
          return i18n.t(fullKey).capitalize();
        }

        const smallKey = "attributes." + _.last(this.name.split("."));
        if (i18n.te(smallKey)) {
          return i18n.t(smallKey).capitalize();
        }

        return this.name.capitalize();
      },
      type: String
    },
    placeholder: {
      type: String
    }
  },
  computed: {
    form() {
      let parent = this.$parent;
      for (let i = 0; i < 10; i++) {
        if (parent == null) {
          throw new Error(`A v-input component must be in a ${Form.name} component`);
        }
        if (parent.$options.name == Form.name) {
          return parent;
        }
        parent = parent.$parent;
      }
      return null;
    }
  },
  methods: {
    inputListener(payload) {
      this.clearErrors();
      this.$emit("input", payload);
    },
    errorMessage(name = null) {
      if (name == null) {
        name = this.name;
      }
      if (this.hasError(name)) {
        return this.errors()[name][0];
      }
      return null;
    },
    hasError(name = null) {
      if (name == null) {
        name = this.name;
      }
      return Object.keys(this.errors()).length > 0 &&
        Object.prototype.hasOwnProperty.call(this.errors(), name) &&
        this.errors()[name].length > 0;
    },
    errors() {
      let parent = this.$parent;
      for (let i = 0; i < 10; i++) {
        if (parent == null) {
          throw new Error(`A v-input component must be in a ${Form.name} component`);
        }
        if (parent.$options.name == Form.name) {
          return parent.errors;
        }
        parent = parent.$parent;
      }
    },
    clearErrors(name = null) {
      if (name == null) {
        name = this.name;
      }
      this.form.clearErrors(name);
    }
  },
  watch: {
    value(newVal) {
      this.input = newVal;
    }
  }
};
